import type { GetNotificationsRequest, GetNotificationsResponse } from '@gdladder/shared/features';
import APIClient from '../APIClient';

export interface NotificationResponse {
    ID: string;
    Message: string;
    IsRead: 0 | 1;
    SentAt: Date;
    ReadAt: Date | null;
}

export default async function GetNotifications(options?: GetNotificationsRequest): Promise<NotificationResponse[]> {
    const res = await APIClient.get<GetNotificationsResponse>('/notifications', { params: { ...options } });

    return res.data.map((notif) => ({
        ID: notif.ID,
        Message: notif.Message,
        IsRead: notif.IsRead,
        SentAt: new Date(notif.SentAt),
        ReadAt: notif.ReadAt !== null ? new Date(notif.ReadAt) : null,
    }));
}
